import { render } from "./VSelectInput.vue?vue&type=template&id=5098050a"
import script from "./VSelectInput.vue?vue&type=script&lang=js"
export * from "./VSelectInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saleem/Sites/unitedtours/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__